const strokeIconClass = "text-primary";

export const ChatChartIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={`${className} ${strokeIconClass}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <line x1="18" y1="20" x2="18" y2="10" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="12" y1="20" x2="12" y2="4" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="6" y1="20" x2="6" y2="14" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ChatEmailIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={`${className} ${strokeIconClass}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline points="22,6 12,13 2,6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ChatDocumentIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={`${className} ${strokeIconClass}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline points="14 2 14 8 20 8" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="16" y1="13" x2="8" y2="13" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="16" y1="17" x2="8" y2="17" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ChatAnalyticsIcon = ({ className = "w-5 h-5" }) => (
  <svg
    className={`${className} ${strokeIconClass}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <circle cx="12" cy="12" r="10" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 2v10l4.5 4.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SUGGESTION_ICON_MAP = {
  chart: ChatChartIcon,
  email: ChatEmailIcon,
  document: ChatDocumentIcon,
  analytics: ChatAnalyticsIcon,
};

export const ChatSuggestionIcon = ({ type, className }) => {
  const Icon = SUGGESTION_ICON_MAP[type];
  if (!Icon) return null;
  return <Icon className={className} />;
};

export default ChatSuggestionIcon;
